import React, { useEffect, useState } from "react";
import {
  Breadcrumb,
  Button,
  Checkbox,
  Col,
  Form,
  Input,
  Row,
  Table,
  Typography,
  Spin,
  Empty,
  Select,
} from "antd";
import {
  SearchOutlined,
  LoadingOutlined,
  ArrowRightOutlined,
} from "@ant-design/icons";
import { Link, useNavigate } from "react-router-dom";
import SearchServices from "../../../services/SearchServices";
import { TableHelper } from "../../../helpers/TableHelper";
import { translate } from "../../../locale";

const { Title } = Typography;

const SearchPatient = () => {
  const [loading, setLoading] = useState(false);
  const [loadingProfessionals, setLoadingProfessionals] = useState(true);
  const [searching, setSearching] = useState(false);
  const [values, setValues] = useState({
    period: 30,
    suscription: "",
    first_name: "",
    last_name: "",
    email: "",
    document: "",
    professional_id: null,
  });
  const [allUsers, setallUsers] = useState([]);
  const [professionals, setProfessionals] = useState([]);
  const navigate = useNavigate();
  const [tableParams, setTableParams] = useState({
    pagination: {
      current: 1,
      pageSize: 25,
      total: 0,
    },
  });
  const [total, setTotal] = useState(0);

  const columns = [
    {
      title: "",
      dataIndex: "actions",
      key: "actions",
      render: (_, record) => (
        <div className="flex space-x-2">
          <Button
            type="text"
            icon={<ArrowRightOutlined />}
            size="small"
            className="border-0"
            onClick={() =>
              navigate(`/admin/buscar-paciente/${record.username}`)
            }
          />
        </div>
      ),
    },
    {
      title: "Apellido",
      dataIndex: "last_name",
      key: "last_name",
      render: (_, record) => (
        <a
          onClick={() => navigate(`/admin/buscar-paciente/${record.username}`)}
          className="text-black hover:text-custom_primary"
        >
          {record.last_name}
        </a>
      ),
      sorter: { multiple: 4 },
    },
    {
      title: "Nombre",
      dataIndex: "first_name",
      key: "first_name",
      render: (_, record) => (
        <a
          onClick={() => navigate(`/admin/buscar-paciente/${record.username}`)}
          className="text-black hover:text-custom_primary"
        >
          {record.first_name}
        </a>
      ),
      sorter: { multiple: 3 },
    },
    {
      title: "Nº de Documento",
      dataIndex: "document",
      key: "document",
      sorter: { multiple: 2 },
    },
    {
      title: "Email",
      dataIndex: "username",
      key: "username",
      sorter: { multiple: 1 },
    },
  ];

  useEffect(() => {
    loadProfessionals();
  }, []);

  useEffect(() => {
    if (
      values.first_name !== "" ||
      values.last_name !== "" ||
      values.email !== "" ||
      values.document !== "" ||
      values.professional_id !== null
    ) {
      searchPatient();
    }
  }, [JSON.stringify(tableParams)]);

  const loadProfessionals = async () => {
    setLoadingProfessionals(true);
    try {
      const response = await SearchServices.Professionals();
      if (response.status >= 200 && response.status < 300) {
        setProfessionals(
          response.data.professionals.map((i) => ({
            value: i.user.id,
            label: `${i.first_name} ${i.last_name}`,
          }))
        );
      }
    } catch (error) {
      console.log(error);
    } finally {
      setLoadingProfessionals(false);
    }
  };

  const searchPatient = async () => {
    setSearching(true);
    try {
      let data = {
        page_size: tableParams.pagination.pageSize,
        page_num: tableParams.pagination.current,
      };
      const sorter = TableHelper.sorterArray(tableParams);
      if (sorter !== null) {
        data = { ...data, order_by: sorter };
      }
      const response = await SearchServices.SearchPatient(values, data);
      if (response.status >= 200 && response.status < 300) {
        let temp_list = [];

        response.data.users.forEach((item, key) => {
          temp_list.push({
            key: key,
            last_name: item.last_name,
            first_name: item.first_name,
            email: item.user.username,
            document:
              item.identity_value && item.identity_value !== "null"
                ? item.identity_value
                : "-",
            username: item.user.username,
          });
        });
        setallUsers(temp_list);
        setTotal(response.data.total_pages * tableParams.pagination.pageSize);
      }
      setSearching(false);
    } catch (error) {
      console.log(error);
      setSearching(false);
    }
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    setValues((v) => ({ ...v, [name]: value }));
  };

  const handleTableChange = (pagination, filters, sorter) => {
    setTableParams({
      pagination,
      filters,
      sorter,
    });

    // `dataSource` is useless since `pageSize` changed
    if (pagination.pageSize !== tableParams.pagination?.pageSize) {
      setallUsers([]);
    }
  };
  const onSelectChange = (value) => {
    setValues((v) => ({ ...v, professional_id: value }));
  };

  return (
    <div className="flex flex-col min-h-full w-screen max-w-7xl pb-16 my-10 mx-0 md:mx-10 px-4 md:px-0">
      <Row gutter={16}>
        <Col className="gutter-row" span="24">
          <Breadcrumb>
            <Breadcrumb.Item>
              <Link to="/admin">Inicio</Link>
            </Breadcrumb.Item>
            <Breadcrumb.Item>Buscar paciente</Breadcrumb.Item>
          </Breadcrumb>
        </Col>
        <Col className="my-4" span="24">
          <Title level={2} className="text-center !text-lg lg:!text-3xl">
            Buscar paciente
          </Title>
        </Col>
      </Row>
      <div className="flex flex-col w-full">
        <Form>
          <div className="flex w-full space-x-4">
            {/* <div className="w-1/4">
              <Form.Item>
                <Checkbox
                  onChange={handleChange}
                  className="border-custom_primary"
                  name="only_my_contacts"
                >
                  Solo mis contactos
                </Checkbox>
              </Form.Item>
            </div> */}
          </div>
          <div className="flex w-full flex-col md:flex-row space-x-0 md:space-x-4 space-y-4 md:space-y-0">
            <Form.Item className="w-full md:w-1/4 mb-0">
              <Input
                placeholder="Apellido"
                onChange={handleChange}
                className="border-custom_primary"
                name="last_name"
              />
            </Form.Item>
            <Form.Item className="w-full md:w-1/4 mb-0">
              <Input
                placeholder="Nombre"
                onChange={handleChange}
                className="border-custom_primary"
                name="first_name"
              />
            </Form.Item>
            <Form.Item className="w-full md:w-1/4 mb-0">
              <Input
                placeholder="Nro. Documento"
                onChange={handleChange}
                className="border-custom_primary"
                name="document"
              />
            </Form.Item>
            <Form.Item className="w-full md:w-1/4 mb-0">
              <Input
                placeholder="Email Usuario"
                onChange={handleChange}
                className="border-custom_primary"
                name="email"
              />
            </Form.Item>
          </div>
          <div className="flex w-full flex-col md:flex-row space-x-0 md:space-x-4 pt-4">
            <Form.Item className="w-full md:w-1/4">
              <Select
                showSearch
                placeholder="Profesional"
                optionFilterProp="children"
                onChange={(e) => onSelectChange(e, "professional_id")}
                bordered={false}
                className="border border-solid border-custom_primary rounded w-full"
                filterOption={(input, option) =>
                  (option?.label ?? "")
                    .toLowerCase()
                    .includes(input.toLowerCase())
                }
                loading={loadingProfessionals}
                options={professionals}
              />
            </Form.Item>
            <div className="w-full md:w-1/4"></div>
            <div className="w-full md:w-1/4"></div>
            <div className="w-full md:w-1/4"></div>
          </div>
          <div className="flex w-full space-x-4 justify-center">
            <Form.Item>
              <Button
                type="primary"
                htmlType="submit"
                className="bg-custom_primary"
                onClick={() => searchPatient()}
              >
                {searching ? (
                  <LoadingOutlined />
                ) : (
                  <SearchOutlined style={{ position: "relative" }} />
                )}
                Buscar
              </Button>
            </Form.Item>
          </div>
        </Form>
      </div>
      <div className="flex flex-col justify-center items-center w-full my-4 bg-gray-200">
        <Title level={3} className="mt-4 !text-lg lg:!text-2xl">
          RESULTADO
        </Title>
      </div>
      <div className="flex flex-col justify-center">
        <Table
          dataSource={allUsers}
          columns={columns}
          loading={loading || searching}
          locale={{
            emptyText: <Empty description={translate("No hay datos")} />,
            sortTitle: translate("Ordenar"),
            triggerDesc: translate("Ordenar (descendente)"),
            triggerAsc: translate("Ordenar (ascendente)"),
            cancelSort: translate("Cancelar orden"),
          }}
          pagination={{ ...tableParams.pagination, total: total }}
          onChange={handleTableChange}
          scroll={{ x: 300 }}
        />
      </div>
    </div>
  );
};

export default SearchPatient;
